import logger from "flow/logger";
import { getBool, getNumber, getString, getUrl } from "flow/manifests/metaParserHelper";

import { IProductEntry } from "./IProductEntry";
import { addFlow3SuffixToProductId, appendDisplayFlow3Suffix } from "./productEntryUtils";
import { IProductEntryMetaFlow3 } from "./IProductEntryMetaFlow3";

export default class ProductEntryFlow3 implements IProductEntry {
    id: string;
    name: string;
    isActive: boolean;
    runtimeContext: string;
    configurationProvider: string;
    broken: boolean = false;
    requiredMinimumLoa: number;
    actors: string[];
    openReplayProjectKey?: string;
    external: boolean = true; // Since we are in Flow 2

    constructor(entryData: Partial<IProductEntryMetaFlow3>) {
        // We add a suffix to avoid id collisions with Flow 2 products
        this.id = addFlow3SuffixToProductId(getString("Id", entryData, undefined));
        this.name = appendDisplayFlow3Suffix(getString("Name", entryData, undefined));
        this.isActive = getBool("IsActive", entryData, false);
        this.runtimeContext = getString("VisibleInRuntimeContext", entryData, undefined);
        this.configurationProvider = getUrl("ConfigurationProvider", entryData);
        this.requiredMinimumLoa = getNumber("RequiredMinimumLoa", entryData, 0);
        this.actors = []; // Not relevant here
        this.openReplayProjectKey = ""; // Not relevant here

        this.validate();
    }

    validate = () => {
        if (!this.id) {
            throw new Error("Product is missing an id in the configuration. Will be ignored until it is fixed.");
        }

        if (!this.name) {
            logger.log("Product " + this.id + " is missing a name in the configuration. Will default to id.");
            this.name = this.id;
        }
    };
}
